// src/services/castingService.ts
// Open calls for cast and crew, and the member's own submissions.

import { buildQuery, studioRequest } from './studioApi';
import type {
  CastingApplication,
  CastingApplicationPayload,
  CastingCall,
  CastingCallSummary,
  PagedResult,
} from '../types/studio';

export interface CastingQuery {
  type?: string;
  search?: string;
  page?: number;
  size?: number;
}

export const castingService = {
  getOpenCalls(
    query: CastingQuery = {},
    signal?: AbortSignal,
  ): Promise<PagedResult<CastingCallSummary>> {
    const search = buildQuery({
      type: query.type,
      search: query.search,
      page: query.page ?? 0,
      size: query.size ?? 24,
    });
    return studioRequest<PagedResult<CastingCallSummary>>(`/casting/calls${search}`, {
      withAuth: false,
      signal,
    });
  },

  /** Sends the token when present so the response can report "you already applied". */
  getCall(slug: string, signal?: AbortSignal): Promise<CastingCall> {
    return studioRequest<CastingCall>(`/casting/calls/${encodeURIComponent(slug)}`, { signal });
  },

  apply(slug: string, payload: CastingApplicationPayload): Promise<CastingApplication> {
    return studioRequest<CastingApplication>(
      `/casting/calls/${encodeURIComponent(slug)}/apply`,
      { method: 'POST', body: payload },
    );
  },

  withdraw(slug: string): Promise<unknown> {
    return studioRequest(`/casting/calls/${encodeURIComponent(slug)}/apply`, { method: 'DELETE' });
  },

  getMyApplications(signal?: AbortSignal): Promise<CastingApplication[]> {
    return studioRequest<CastingApplication[]>('/casting/my-applications', { signal });
  },
};

export default castingService;
